
    export default {
        inject: {
            onFilterValueChanged: {
                default: null,
            },
            onFilterApply: {
                default: null,
            },
            onFilterVisibilityChanged: {
                default: null,
            },
            registerFilter: {
                default: null,
            },
            unregisterFilter: {
                default: null,
            },
        },
        props: {
            fixed: { default: false, type: Boolean },
            optional: { default: false, type: Boolean },
            displayName: { required: true, type: String },
            modelValue: { required: true },
        },
        emits: ['update:modelValue', 'apply-filter', 'visibility-changed', 'value-changed'],
        data () {
            return {
                isVisible: !this.optional,
                name: this.label,
            };
        },
        methods: {
            applyFilter() {
                this.$emit('apply-filter');
                if (this.onFilterApply) {
                    this.onFilterApply();
                }
            },
            // Override this method in extending components
            afterValueChanged(newValue, oldValue) {},
        },
        watch: {
            isVisible(newValue) {
                this.$emit('visibility-changed', newValue);
                if (this.onFilterVisibilityChanged) {
                    this.onFilterVisibilityChanged(newValue);
                }
            },
            modelValue: {
                handler(newValue, oldValue) {
                    this.$emit('value-changed', newValue);
                    if (this.onFilterValueChanged) {
                        this.onFilterValueChanged(newValue);
                    }
                    this.afterValueChanged(newValue, oldValue);
                },
                deep: true,
            },
        },
        computed: {
            // In Vue 3 $attrs includes class/style. Filters apply the consumer's class to their
            // grid-cell root; spreading raw $attrs onto the inner field would leak that class onto
            // the field and break its size. Pass attrs without class/style to the field instead.
            fieldAttrs() {
                const rest = { ...this.$attrs };
                delete rest.class;
                delete rest.style;
                return rest;
            },
        },
        mounted() {
            if (this.registerFilter) {
                this.registerFilter(this);
            }
        },
        beforeUnmount() {
            if (this.unregisterFilter) {
                this.unregisterFilter(this);
            }
        },
    };
